import { render, staticRenderFns } from "./VueSlotsComponent.vue?vue&type=template&id=600cd16a&scoped=true&"
import script from "./VueSlotsComponent.vue?vue&type=script&lang=js&"
export * from "./VueSlotsComponent.vue?vue&type=script&lang=js&"
import style0 from "./VueSlotsComponent.vue?vue&type=style&index=0&id=600cd16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600cd16a",
  null
  
)

export default component.exports